import Endpoints from "../config/endpoints"
import Request from "../helpers/request"

export default class ReleaseRequests {

    static cache = {}

    static search(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.release.search, filter, {}, true)

    }

    static oldSearch(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.release.oldSearch, filter)
            .then(res => !!res ? res.productrelease : null)

    }

    static get(code) {

        if (ReleaseRequests.cache[code])
            return Promise.resolve(ReleaseRequests.cache[code])


        return Request
            .getInstance()
            .createGetRequest(`${Endpoints.release.get}/${code}`, {}, {}, true)
            .then(res=> {
                const result = !!res ? res.data : null
                ReleaseRequests.cache[code] = result

                return result
            })
    }

    static getOld(code) {

        if (ReleaseRequests.cache[code])
            return Promise.resolve(ReleaseRequests.cache[code])


        return Request
            .getInstance()
            .createGetRequest(`${Endpoints.release.getOld}/${code}`, {})
    }

    static getCoursePersonList(filters) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.release.coursePersonList, filters)
    }
}



// WEBPACK FOOTER //
// ./src/requests/release-requests.js